import { render, staticRenderFns } from "./Ips.vue?vue&type=template&id=6c4e330c&"
import script from "./Ips.vue?vue&type=script&lang=js&"
export * from "./Ips.vue?vue&type=script&lang=js&"
import style0 from "./Ips.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports